import { useContext } from 'react';
import {
  LAYOUT_DEFAULT,
  LAYOUT_EMPTY,
  LAYOUT_EMPTY_FULL,
  LAYOUT_EVENT,
  LAYOUT_WITHOUT_SIDEBAR,
} from '@contexts/layout/layout.type';
import { LayoutContext } from '@contexts/layout/layout-context';

import { LayoutDefault } from './components/layout-default';
import { LayoutEmpty } from './components/layout-empty';
import { LayoutEmptyFull } from './components/layout-empty-full';
import { LayoutEvents } from './components/layout-events';
import { LayoutWithoutSidebar } from './components/layout-without-sidebar';
import { Props } from './layout.type';

export const Layout = ({ children }: Props) => {
  const { layoutType } = useContext(LayoutContext);

  if (layoutType === LAYOUT_DEFAULT) {
    return <LayoutDefault>{children}</LayoutDefault>;
  }

  if (layoutType === LAYOUT_EVENT) {
    return <LayoutEvents>{children}</LayoutEvents>;
  }
  if (layoutType === LAYOUT_WITHOUT_SIDEBAR) {
    return <LayoutWithoutSidebar>{children}</LayoutWithoutSidebar>;
  }
  if (layoutType === LAYOUT_EMPTY) {
    return <LayoutEmpty>{children}</LayoutEmpty>;
  }
  if (layoutType === LAYOUT_EMPTY_FULL) {
    return <LayoutEmptyFull>{children}</LayoutEmptyFull>;
  }

  return <>{children}</>;
};
